"use client";

import type { HomeTrustContent } from "@/lib/page-content-types";

const defaultTrust: HomeTrustContent = {
  title: "Built on trust",
  description:
    "Not just opinion, a reference backed by editorial governance and transparent practices.",
  signals: ["Editorial Policy", "Citations & Sources", "Version History", "Expert Review"],
};

export function TrustSection({ content = defaultTrust }: { content?: HomeTrustContent }) {
  return (
    <section className="py-32 lg:py-48" style={{ backgroundColor: "var(--charcoal)" }}>
      <div className="mx-auto max-w-screen-2xl px-8 lg:px-16">
        <div className="mx-auto max-w-7xl">
          <div className="mb-24 text-center">
            <h2
              className="mb-6"
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "clamp(2rem, 5vw, 4rem)",
                fontWeight: 300,
                lineHeight: "var(--line-height-tight)",
                color: "var(--paper)",
                letterSpacing: "-0.02em",
              }}
            >
              {content.title}
            </h2>
            <p
              className="mx-auto max-w-2xl"
              style={{
                fontFamily: "var(--font-body)",
                fontSize: "var(--text-base)",
                lineHeight: "var(--line-height-body)",
                color: "var(--stone)",
                fontWeight: 300,
              }}
            >
              {content.description}
            </p>
          </div>

          <div className="mx-auto max-w-3xl">
            {content.signals.map((signal, index) => (
              <div
                key={signal}
                className="group"
                style={{
                  borderTop: index === 0 ? "1px solid rgba(232, 232, 229, 0.2)" : "none",
                  borderBottom: "1px solid rgba(232, 232, 229, 0.2)",
                }}
              >
                <a href="#" className="flex items-center justify-between py-8 transition-opacity duration-200 hover:opacity-50">
                  <span
                    style={{
                      fontFamily: "var(--font-display)",
                      fontSize: "var(--text-xl)",
                      fontWeight: 300,
                      color: "var(--paper)",
                      letterSpacing: "-0.01em",
                    }}
                  >
                    {signal}
                  </span>
                  <span
                    className="transition-transform duration-200 group-hover:translate-x-2"
                    style={{
                      fontFamily: "var(--font-body)",
                      fontSize: "var(--text-sm)",
                      color: "var(--stone)",
                      letterSpacing: "0.05em",
                    }}
                  >
                    →
                  </span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
